// idle store — detecta inatividade do usuario (sem mouse/keyboard/touch
// por N minutos) e expõe um writable `isIdle` boolean.
//
// Por que existe: WebSocket no Cloud Run cobra CPU enquanto aberto.
// Aba esquecida = consumo continuo. Quando idle no lobby, fechamos o
// WS pra parar de consumir recursos. Quando o user volta (qualquer
// movimento/tecla), reconecta.
//
// IMPORTANTE: idle nao desconecta DURANTE partida — perderia o turno
// (auto-play do timer). O wire em App.svelte só fecha WS se isIdle E
// !inMatch.
//
// Felipe 2026-05-25: free tier do Cloud Run cobrado por tempo de WS
// aberto. Aba aberta 8h = 28k vCPU-sec. 3min suficiente pra detectar.

import { writable } from 'svelte/store';

const IDLE_TIMEOUT_MS = 3 * 60 * 1000; // 3 minutos

export const isIdle = writable(false);

let timer: number | null = null;

function reset() {
  if (timer !== null) {
    clearTimeout(timer);
  }
  isIdle.set(false);
  timer = window.setTimeout(() => {
    isIdle.set(true);
  }, IDLE_TIMEOUT_MS);
}

const events: (keyof WindowEventMap)[] = [
  'mousemove',
  'keydown',
  'touchstart',
  'pointerdown',
  'scroll',
  'click',
  'focus',
];

// Side effect: registra listeners de atividade no module load.
// Aba aberta = listeners ativos = qualquer movimento reseta o timer.
if (typeof window !== 'undefined') {
  for (const ev of events) {
    window.addEventListener(ev, reset, { passive: true });
  }
  // Visibility:
  //   - aba sai do foco (alt-tab, troca de aba) → marca idle IMEDIATO
  //     (sem esperar 3min). Economia maxima de WS no Cloud Run.
  //   - aba volta → reset timer normal (3min).
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      if (timer !== null) clearTimeout(timer);
      isIdle.set(true);
    } else {
      reset();
    }
  });
  // Inicia o timer
  reset();
}
